import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum OrganizationTaskTemplatesViewColumn {
    NAME = "name",
    ASSIGNEE = "assignee",
    TASK_TYPE = "taskType",
    CLOSE_STAGE = "closeStage",
    DEADLINE = "deadline",
    ESTIMATE = "estimate",
    CLIENT = "client",
    SERVICE_TEMPLATES = "serviceTemplates",
    CREATED_BY = "createdBy",
    CREATED = "created",
    UPDATED_BY = "updatedBy",
    UPDATED = "updated",
    ACTIONS = "actions",
}

const makeColumnSchema = (id: OrganizationTaskTemplatesViewColumn) =>
    ColumnSchema.extend({ id: z.literal(id) });

export const OrganizationTaskTemplatesViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.ORGANIZATION_TASK_TEMPLATES),
    columns: z.array(
        z.discriminatedUnion("id", [
            makeColumnSchema(OrganizationTaskTemplatesViewColumn.NAME),
            makeColumnSchema(OrganizationTaskTemplatesViewColumn.ASSIGNEE),
            makeColumnSchema(OrganizationTaskTemplatesViewColumn.TASK_TYPE),
            makeColumnSchema(OrganizationTaskTemplatesViewColumn.CLOSE_STAGE),
            makeColumnSchema(OrganizationTaskTemplatesViewColumn.DEADLINE),
            makeColumnSchema(OrganizationTaskTemplatesViewColumn.ESTIMATE),
            makeColumnSchema(OrganizationTaskTemplatesViewColumn.CLIENT),
            makeColumnSchema(
                OrganizationTaskTemplatesViewColumn.SERVICE_TEMPLATES,
            ),
            makeColumnSchema(OrganizationTaskTemplatesViewColumn.CREATED_BY),
            makeColumnSchema(OrganizationTaskTemplatesViewColumn.CREATED),
            makeColumnSchema(OrganizationTaskTemplatesViewColumn.UPDATED_BY),
            makeColumnSchema(OrganizationTaskTemplatesViewColumn.UPDATED),
            makeColumnSchema(OrganizationTaskTemplatesViewColumn.ACTIONS),
        ]),
    ),
});

export type OrganizationTaskTemplatesView = z.infer<
    typeof OrganizationTaskTemplatesViewSchema
>;
